import React from 'react';
import { TableCell } from '@mui/material';
import _ from 'lodash';
import { cpHeaders, sgHeaders, tgHeaders } from '../../utils/balance-accounts';
import { getNumberComma } from '../../utils/numberUtils';

const OrderStaticTableCell = ({ headerRows, data }) => {
  if (!headerRows || !data) {
    return null;
  }

  return (
    headerRows &&
    headerRows.map((field, fIndex) => {
      let headerTyp = null;
      if (field.id === 'SG') {
        headerTyp = sgHeaders;
      } else if (field.id === 'TG') {
        headerTyp = tgHeaders;
      } else if (field.id === 'CP') {
        headerTyp = cpHeaders;
      } else {
        //{ id: 'sales', name: '매출액' },
        headerTyp = [{ id: field.val, name: field?.name }];
      }

      return (
        headerTyp.length > 0 &&
        headerTyp.map((type, tIndex) => {
          let key = `${fIndex}_${tIndex}`;

          let value = _.has(data, `${field.val}.${type.id}`)
            ? data[field.val][type.id]
            : '-';
          let formatValue =
            type.id !== 'profit' ? getNumberComma(value) : value;

          return (
            <TableCell
              sx={{ width: '100px', paddingLeft: 0 }}
              align="right"
              key={key}
            >
              {formatValue}
            </TableCell>
          );
        })
      );
    })
  );
};

export default OrderStaticTableCell;
